"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var Text_1 = __importDefault(require("../../Text"));
var MenuLink = (0, styled_1.default)(Text_1.default)(function (_a) {
    var colorTheme = _a.colorTheme, active = _a.active;
    return ({
        display: 'flex',
        fontSize: '14px',
        lineHeight: '26px',
        color: colorTheme === 'DARK' ? 'rgba(255, 255, 255, 0.8)' : 'black',
        backgroundColor: active ? 'rgba(255, 255, 255, 0.08)' : 'transparent',
        padding: '4px 12px',
        margin: '5px 0px'
    });
});
MenuLink.defaultProps = { as: 'li' };
exports.default = MenuLink;
